const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '') || '';

export function Logo(props) {
  return (
    <div {...props}>
      <div className="relative w-10 h-10 flex-shrink-0">
        <img src={`${base}/transSmilesFlowFavicon.png`} width={40} height={40} alt="SmilesFlow" className="object-contain w-full h-full" />
      </div>
    </div>
  );
}
